import { DeleteResponse, ProjectInfoListResponse, ProjectInfoResponse } from '../dto/ResDtoRepository';
import { CreateProjectInfoReq, UpdateProjectInfoBulkReq, RemoveProjectInfoReq, UpdateReorderListReq, CreateProjectInfoBulkReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';


export const getProjectInfoList = async (aui: string, projectId: string): Promise<ProjectInfoListResponse> => {
  return sendGetApiRequest<ProjectInfoListResponse>(`/api/v1/project-info?aui=${aui}&projectId=${projectId}`);
};

export const createProjectInfo = async (aui: string, data: CreateProjectInfoReq): Promise<ProjectInfoResponse> => {
  return sendApiRequest<ProjectInfoResponse>('post', `/api/v1/project-info?aui=${aui}`, data);
};

export const createProjectInfoBulk = async (aui: string, data: CreateProjectInfoBulkReq): Promise<ProjectInfoListResponse> => {
  return sendApiRequest<ProjectInfoListResponse>('post', `/api/v1/project-info/bulk?aui=${aui}`, data);
};

export const updateProjectInfoBulk = async (aui: string, data: UpdateProjectInfoBulkReq): Promise<ProjectInfoListResponse> => {
  return sendApiRequest<ProjectInfoListResponse>('put', `/api/v1/project-info/bulk?aui=${aui}`, data);
};

export const deleteProjectInfo = async (aui: string, data: RemoveProjectInfoReq): Promise<DeleteResponse> => {
  return sendDeleteApiRequest<DeleteResponse>(`/api/v1/project-info?aui=${aui}&projectInfoId=${data.id}`);
};

export const reorderProjectInfo = async (aui: string, data: UpdateReorderListReq): Promise<ProjectInfoListResponse> => {
  return sendApiRequest<ProjectInfoListResponse>('put', `/api/v1/project-info/reorder?aui=${aui}`, data);
};